import React from "react";

type Props = {
    children: React.ReactNode;
    className?: string; // Allow overriding/adding classes if really needed
};

export const PageLayout = ({ children, className = "" }: Props) => {
    return (
        <main className={`mt-16 px-10 w-full mb-10 min-h-screen ${className}`}>
            {children}
        </main>
    );
};
